"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The MailgunEventPayloadSignature model module.
 * @module model/MailgunEventPayloadSignature
 * @version 1.1.3-alpha.1
 */
class MailgunEventPayloadSignature {
  /**
   * Constructs a new <code>MailgunEventPayloadSignature</code>.
   * @alias module:model/MailgunEventPayloadSignature
   * @param timestamp {Number} 
   * @param token {String} 
   * @param signature {String} 
   */
  constructor(timestamp, token, signature) {
    MailgunEventPayloadSignature.initialize(this, timestamp, token, signature);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, timestamp, token, signature) {
    obj['timestamp'] = timestamp;
    obj['token'] = token;
    obj['signature'] = signature;
  }

  /**
   * Constructs a <code>MailgunEventPayloadSignature</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MailgunEventPayloadSignature} obj Optional instance to populate.
   * @return {module:model/MailgunEventPayloadSignature} The populated <code>MailgunEventPayloadSignature</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new MailgunEventPayloadSignature();
      if (data.hasOwnProperty('timestamp')) {
        obj['timestamp'] = _ApiClient.default.convertToType(data['timestamp'], 'Number');
      }
      if (data.hasOwnProperty('token')) {
        obj['token'] = _ApiClient.default.convertToType(data['token'], 'String');
      }
      if (data.hasOwnProperty('signature')) {
        obj['signature'] = _ApiClient.default.convertToType(data['signature'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>MailgunEventPayloadSignature</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MailgunEventPayloadSignature</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of MailgunEventPayloadSignature.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['token'] && !(typeof data['token'] === 'string' || data['token'] instanceof String)) {
      throw new Error("Expected the field `token` to be a primitive type in the JSON string but got " + data['token']);
    }
    // ensure the json data is a string
    if (data['signature'] && !(typeof data['signature'] === 'string' || data['signature'] instanceof String)) {
      throw new Error("Expected the field `signature` to be a primitive type in the JSON string but got " + data['signature']);
    }
    return true;
  }
}
MailgunEventPayloadSignature.RequiredProperties = ["timestamp", "token", "signature"];

/**
 * @member {Number} timestamp
 */
MailgunEventPayloadSignature.prototype['timestamp'] = undefined;

/**
 * @member {String} token
 */
MailgunEventPayloadSignature.prototype['token'] = undefined;

/**
 * @member {String} signature
 */
MailgunEventPayloadSignature.prototype['signature'] = undefined;
var _default = exports.default = MailgunEventPayloadSignature;